import { CreditReviewStatus } from '@40seas/entities/credit-reviews';
import { EnumColor } from '@40seas/frontend/common/providers';
import { InsuranceApplicationStatus } from '@40seas/entities/insurance';

export const insuranceApplicationStatusColorMapping = {
    [InsuranceApplicationStatus.Pending]: 'info',
    [InsuranceApplicationStatus.Unsupported]: 'warning',
    [InsuranceApplicationStatus.Success]: 'success',
    [InsuranceApplicationStatus.Failed]: 'error',
} as { [key in InsuranceApplicationStatus]: EnumColor };
